module.exports = __webpack_public_path__ + "res/Roboto-Bold-webfont.woff?e86570e22e4eb8b31936d62c3e7461d7";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Bold-webfont.woff
// module id = 28
// module chunks = 0